export enum SortOrders {
	RELEVANCY_SORT = 'web.item.sorting.scheme.relevancy',
	ALPHABETICAL_SORT = 'web.item.sorting.scheme.alphabetical',
}
